window.addEventListener("scroll", stickyMenu);

let menu = $("#upheads-menu");

function stickyMenu() {
  if (menu) {
    if (window.scrollY > 16 && window.innerWidth < 1300) {
      menu.css({
        position: "fixed",
        "padding-top": "1rem",
      });
    } else if (window.innerWidth < 1300) {
      menu.css({
        "padding-top": "2rem",
        position: "absolute",
      });
    }
  }
}
